var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNishat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-153 -46 652 652",
    style: {
      enableBackground: "new -153 -46 652 652"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1E115F;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#1E115F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-91.9,528.8V424.5h14.3l55.5,81.9v-81.9h13.4v104.3H-23l-55.5-82v82H-91.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.5,528.8V424.5h14v104.3H19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.9,495.3l13.2-1.1c0.6,5.2,2.1,9.5,4.4,12.8c2.3,3.3,5.8,6,10.6,8.1c4.8,2.1,10.2,3.1,16.2,3.1 c5.3,0,10-0.8,14.1-2.3c4.1-1.6,7.1-3.7,9.1-6.4c2-2.7,3-5.7,3-8.9c0-3.3-1-6.1-2.9-8.6c-1.9-2.4-5.1-4.5-9.5-6.2 c-2.8-1.1-9.1-2.8-18.8-5.1c-9.7-2.3-16.5-4.5-20.4-6.5c-5-2.6-8.8-5.8-11.3-9.7c-2.5-3.9-3.7-8.2-3.7-13c0-5.3,1.5-10.2,4.5-14.8 c3-4.6,7.4-8,13.3-10.4c5.8-2.4,12.3-3.6,19.4-3.6c7.8,0,14.7,1.2,20.7,3.7c6,2.5,10.6,6.2,13.8,11c3.2,4.8,4.9,10.3,5.2,16.4 l-13.4,1c-0.7-6.6-3.2-11.6-7.3-14.9c-4.2-3.4-10.3-5.1-18.4-5.1c-8.5,0-14.6,1.5-18.5,4.6c-3.9,3.1-5.8,6.8-5.8,11.1 c0,3.8,1.4,6.8,4.1,9.3c2.7,2.4,9.7,4.9,21.1,7.4c11.4,2.5,19.2,4.8,23.4,6.7c6.1,2.8,10.7,6.3,13.6,10.6 c2.9,4.3,4.4,9.2,4.4,14.8c0,5.6-1.6,10.8-4.8,15.7c-3.2,4.9-7.8,8.7-13.9,11.5s-12.8,4.1-20.4,4.1c-9.6,0-17.6-1.4-24-4.1 c-6.5-2.7-11.5-6.9-15.2-12.4C58,508.5,56.1,502.3,55.9,495.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162,528.8V424.5h14v42.8h54.9v-42.8h14v104.3h-14v-49.2H176v49.2H162z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.9,528.8l40.6-104.3h15.1l43.2,104.3h-15.9l-12.3-31.6h-44.2l-11.6,31.6H258.9z M289.4,486h35.8l-11-28.9 c-3.4-8.8-5.9-16-7.5-21.6c-1.3,6.7-3.2,13.3-5.7,19.9L289.4,486z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M387.4,528.8v-92h-34.8v-12.3h83.7v12.3h-34.9v92H387.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-101.6,53.6c0-12.7,7.8-23,17.4-23c9.6,0,17.4,10.3,17.4,23v317.6c0,12.7-7.8,23-17.4,23 c-9.6,0-17.4-10.3-17.4-23V53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-45.3,53.6c0-12.7,7.8-23,17.4-23c9.6,0,17.4,10.3,17.4,23v317.6c0,12.7-7.8,23-17.4,23 c-9.6,0-17.4-10.3-17.4-23V53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11,53.6c0-12.7,7.8-23,17.4-23c9.6,0,17.4,10.3,17.4,23v317.6c0,12.7-7.8,23-17.4,23 c-9.6,0-17.4-10.3-17.4-23V53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.3,53.6c0-12.7,7.8-23,17.4-23c9.6,0,17.4,10.3,17.4,23v317.6c0,12.7-7.8,23-17.4,23 c-9.6,0-17.4-10.3-17.4-23V53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.7,189.2L122.7,189.2c8.1-6,21.5,1.2,30,16.3l84.1,149.3c8.5,15,14.3,29.1,2.2,38.3 c-11.8,8.9-23-1.3-31.4-16.3l-84.1-149.3C114.9,212.3,114.6,195.2,122.7,189.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.9,150.7c0,0-10.6,11.2,3.3,18.5c0,0,7.9,1.8,10.8-2c0,0,12.1-2.9,18,5.8c14.5,21.3,25.1,42.1,25.1,42.1 l104.7,179.1c0,0,9.4,10,20.5,2.9c14.2-9.1,5.4-27.2-1.6-37.9L197,176.5c0,0-17.6-38.6-51.9-34.5 C145.1,142,126.2,143.1,120.9,150.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.7,123.1c0,0,20.8-13.9,37.7-4c0,0,15.9,1.2,36.6,33L295,299.9l49.7,86.4c0,0,11.9,18.4,25.4,6.2 c8.4-7.7,7.5-18.6-1.5-34.4l-80.9-141.5c0,0-53.7-93.8-61.1-102c0,0-39.6-51.2-98.1-14.2C119.2,108.1,117.8,122.8,133.7,123.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.9,59.4c0,0-7.1,8.8,1.4,15.3c1.9,3.2,9.6,2.2,17.3-3.3c0,0,46.1-23.9,90.9,12.3c0,0,26.4,32,38.7,59.4 c0,0,132.9,247.4,147.3,251.2c0,0,25.4,9.1,20.8-23.3l-89-160.9c0,0-73.2-131.4-86.3-142.8C262,67.3,199.4-4.3,120.9,59.4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNishat);
export default __webpack_public_path__ + "static/media/Nishat.2248c499f4779202d02f3ea02425fdd9.svg";
export { ForwardRef as ReactComponent };